import Footer from "../Footer";import { useTranslation } from 'react-i18next';


const NAVBAR_HEIGHT = 80;

export default function DQLogix() {
  return (
    <div className="min-h-screen bg-white">

      {/* ================= HERO : CONTENT + IMAGE ================= */}
      <section
        className="relative bg-white overflow-hidden"
        style={{ paddingTop: NAVBAR_HEIGHT }}
      >
        <div className="relative container mx-auto px-4 py-10">

          {/* ===== BOXED CONTENT (LIKE LANDING PAGE) ===== */}
          <div
            className="
              relative
              rounded-3xl
              bg-gradient-to-r from-white via-purple-50/60 to-white
              border border-purple-100
              px-6 md:px-10 py-2
            "
          >
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-16 items-center">

              {/* LEFT CONTENT — 2/3 */}
              <div className="lg:col-span-2">
                <div>

                  <h1
                    className="block mt-2 pb-2 text-4xl md:text-4xl font-semibold bg-gradient-to-r from-pink-800 via-purple-600 to-indigo-600 bg-clip-text text-transparent">
                    DQ - Website & Digital Marketing
                  </h1>

                  <p className="mt-0 text-md text-gray-400 max-w-lg">
                    Shipment to Settlement. Fully Digital.
                  </p>

                  <p className="mt-6 text-md text-gray-600 leading-relaxed">
                    DQ-Logix is a powerful logistics management software designed to
                    digitize and control your entire logistics operation — from
                    shipment booking and vehicle allocation to expense tracking and
                    profit & loss analysis. Built for Indian logistics businesses,
                    DQ-Logix replaces manual processes with a centralized, real-time
                    platform that improves efficiency, transparency, and profitability.
                  </p>
                </div>
              </div>

              {/* RIGHT IMAGE — 1/3 */}
              <div className="lg:col-span-1 flex justify-center lg:justify-end">
                <div
                  className="
                    relative
                    rounded-2xl
                    bg-white/70 backdrop-blur-sm
                    p-4
                  "
                >
                  <img
                    src="/images/DQlogix.jpeg"
                    alt="DQ Logix Logistics Flow"
                    className="
                      w-[420px]
                      max-w-full
                      object-contain
                      rounded-xl
                    "
                  />
                </div>
              </div>

            </div>
          </div>

        </div>
      </section>


      {/* ================= FEATURES AS CARDS ================= */}
      <section className="py-20 bg-gray-50 relative">
        {/* ===== CREATIVE GRID PATTERN BACKGROUND ===== */}
        <div className="absolute inset-0 pointer-events-none overflow-hidden">

          {/* GRID LINES */}
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `
                linear-gradient(to right, rgba(124,58,237,0.08) 2px, transparent 1px),
                linear-gradient(to bottom, rgba(124,58,237,0.08) 2px, transparent 1px)
              `,
              backgroundSize: "32px 32px",
            }}
          />

          {/* CENTER SOFT GLOW */}
          <div className="absolute inset-0 bg-gradient-to-r from-white via-purple-100/40 to-white" />
        </div>
        <div className="container mx-auto px-4">

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

            {[
              {
                title: "End-to-End Logistics Control",
                items: [
                  "Digital shipment booking & dispatch",
                  "Vehicle and driver allocation",
                  "Real-time trip & delivery tracking",
                  "Digital Proof of Delivery (POD)",
                  "Automated billing & settlement",
                ],
              },
              {
                title: "Complete Expense Management",
                items: [
                  "Trip-wise expense recording",
                  "Vehicle & route-wise cost tracking",
                  "Centralized expense control",
                  "Accurate shipment cost allocation",
                ],
              },
              {
                title: "Real-Time Profit & Loss (P&L)",
                items: [
                  "Shipment-wise P&L",
                  "Trip & vehicle profitability",
                  "Automated freight vs expense comparison",
                  "Margin improvement insights",
                ],
              },
              {
                title: "Powerful Reports & Dashboards",
                items: [
                  "Live operational dashboards",
                  "Expense & profitability reports",
                  "Pending POD & payment tracking",
                  "MIS reports for management",
                ],
              },
              {
                title: "Built for Indian Logistics",
                items: [
                  "Cloud-based & mobile-friendly",
                  "Secure & scalable architecture",
                  "Multi-branch & multi-user support",
                  "For transporters & fleet owners",
                ],
              },
            ].map((card, idx) => (
              <div
                key={idx}
                className="
                  bg-white/70 backdrop-blur-sm
                  rounded-xl p-6
                  border border-purple-100
                  hover:shadow-lg transition
                "
              >
                <div className="relative">
                  <h3 className="text-lg font-semibold text-gray-800 mb-4 bg-gradient-to-r from-pink-800 via-purple-600 to-indigo-600
                    bg-clip-text text-transparent
                    pb-4
                    after:content-['']
                    after:absolute after:left-0 after:bottom-0
                    after:h-[1px] after:w-full
                    after:bg-gradient-to-r after:from-purple-300 after:to-white">
                    {card.title}
                  </h3>
                </div>

                <ul className="space-y-3 text-gray-600">
                  {card.items.map((item, i) => (
                    <li key={i} className="flex gap-3">
                      <span className="mt-1 w-5 h-5 flex items-center justify-center rounded-full bg-purple-100 text-purple-700 text-xs font-bold">
                        ✓
                      </span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
